import {FormattedMessage} from "react-intl";
import React from "react";

export const headerCellsArrayCommonDocs = [
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-vatType"
        defaultMessage="VAT type"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-description"
        defaultMessage="description"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-quantity"
        defaultMessage="quantity"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-price"
        defaultMessage="price"
      />
    )
  },
  {
    showMarkNecessary: false,
    label: ''
  },

];
export const headerCellsArrayReceiptCheque = [
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-cheque-date"
        defaultMessage="Date"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-cheque-bankName"
        defaultMessage="Bank name"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-cheque-bankBranch"
        defaultMessage="Bank branch"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-cheque-bankAccount"
        defaultMessage="Bank account"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-cheque-chequeNum"
        defaultMessage="Cheque number"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-cheque-price"
        defaultMessage="Price"
      />
    )
  },
  {
    showMarkNecessary: false,
    label: ''
  },
];
export const headerCellsArrayReceiptBankTransfer = [
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-bankTransfer-date"
        defaultMessage="Date"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-bankTransfer-bankName"
        defaultMessage="Bank name"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-bankTransfer-bankBranch"
        defaultMessage="Bank branch"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-bankTransfer-bankAccount"
        defaultMessage="Bank account"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-bankTransfer-price"
        defaultMessage="Price"
      />
    )
  },
  {
    showMarkNecessary: false,
    label: ''
  },
];
export const headerCellsArrayReceiptCreditCard = [
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-creditCard-date"
        defaultMessage="Date"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-creditCard-cardNum"
        defaultMessage="Card number"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-creditCard-cardType"
        defaultMessage="Card type"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-creditCard-dealType"
        defaultMessage="Deal type"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-creditCard-numPayments"
        defaultMessage="Number of payments"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-creditCard-price"
        defaultMessage="Price"
      />
    )
  },
  {
    showMarkNecessary: false,
    label: null
  },
];
export const headerCellsArrayReceiptPaymentApp = [
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-paymentApp-date"
        defaultMessage="Date"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-paymentApp-appType"
        defaultMessage="App type"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-paymentApp-accountId"
        defaultMessage="Account ID"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-paymentApp-transactionId"
        defaultMessage="Transaction ID"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-paymentApp-price"
        defaultMessage="Price"
      />
    )
  },
  {
    showMarkNecessary: false,
    label: null
  },
];
export const headerCellsArrayReceiptPayPal = [
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-payPal-date"
        defaultMessage="Date"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-payPal-accountId"
        defaultMessage="Account ID"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-payPal-transactionId"
        defaultMessage="Transaction ID"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-payPal-price"
        defaultMessage="Price"
      />
    )
  },
  {
    showMarkNecessary: false,
    label: ''
  },
];
export const headerCellsArrayReceiptCash = [
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-cash-date"
        defaultMessage="Date"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-cash-price"
        defaultMessage="Price"
      />
    )
  },
  {
    showMarkNecessary: false,
    label: ''
  },
];
export const headerCellsArrayReceiptOther = [
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-other-date"
        defaultMessage="Date"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-other-subType"
        defaultMessage="Sub type"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-other-transactionId"
        defaultMessage="transaction ID"
      />
    )
  },
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-other-price"
        defaultMessage="Price"
      />
    )
  },
  {
    showMarkNecessary: false,
    label: null
  },
];
export const headerCellsArrayReceiptWithholdingTax = [
  {
    showMarkNecessary: true,
    label: (
      <FormattedMessage
        id="customer-details-popup-create-document-label-rows-withholdingTax-price"
        defaultMessage="Withholding tax"
      />
    )
  },
  {
    showMarkNecessary: false,
    label: ''
  },
];
